import * as React from 'react';
import classnames from 'classnames';
import { Checkbox } from '@grandvisionhq/elements';

/**
 * @deprecated -
 * Use the new CheckboxList from the Form package.
 * That one doesn't uses the deprecated Checkbox.
 */ const CheckboxList = function({ idPrefix , items , selectedItems , getItemIdentifier , renderItem , renderTrailingItem , onChange , isItemDisabled , checkboxAlignment ='top' , className , itemClassName  }) {
    const handleChange = React.useCallback(({ value , checked  })=>{
        if (!onChange) {
            return;
        }
        const newValues = checked ? [
            ...selectedItems,
            value
        ] : selectedItems.filter((i)=>getItemIdentifier(i) !== getItemIdentifier(value)
        );
        onChange(newValues);
    }, [
        selectedItems,
        getItemIdentifier,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: classnames('checkbox-list', className)
    }, items.map((item)=>{
        const id = idPrefix + String(getItemIdentifier(item));
        const isSelected = selectedItems.some((i)=>getItemIdentifier(i) === getItemIdentifier(item)
        );
        const isDisabled = isItemDisabled === null || isItemDisabled === void 0 ? void 0 : isItemDisabled(item);
        const trailingMarkup = renderTrailingItem === null || renderTrailingItem === void 0 ? void 0 : renderTrailingItem(item);
        return /*#__PURE__*/ React.createElement("div", {
            key: id,
            className: classnames('checkbox-list__item', itemClassName)
        }, /*#__PURE__*/ React.createElement("div", {
            className: `checkbox-list__item-checkbox checkbox-list__item-checkbox--${checkboxAlignment}`
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            id: id,
            value: item,
            checked: isSelected,
            disabled: isDisabled,
            onChange: handleChange
        })), /*#__PURE__*/ React.createElement("div", {
            className: "checkbox-list__item-content"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "checkbox-list__item-label",
            htmlFor: id
        }, renderItem(item)), trailingMarkup && /*#__PURE__*/ React.createElement("span", {
            className: "checkbox-list__item-trailing"
        }, trailingMarkup)));
    }));
};
var CheckboxList$1 = CheckboxList;

export { CheckboxList$1 as default };
//# sourceMappingURL=CheckboxList.js.map
